function initBrackets() {
  const texts = document.querySelectorAll('a .text, button .text');

  texts.forEach(text => {
    const clickable = text.closest('a, button');
    if (!clickable) return;
    const parent = text.parentElement;

    const leftBrackets  = parent.querySelectorAll('.bracket-left, .bracket-left-s');
    const rightBrackets = parent.querySelectorAll('.bracket-right, .bracket-right-s');


    
    const animate = (e) => {
      const isLink = clickable.tagName.toLowerCase() === 'a';
      const href = isLink ? clickable.getAttribute('href') : null;

      if ((isLink && (!href || href === '#')) || clickable.disabled) e.preventDefault();

      // Measure text width dynamically
      const textWidth = text.offsetWidth;
      const moveDist = textWidth / 2; // each bracket moves half the text width

      // apply transforms
      leftBrackets.forEach(el => {
        el.style.transform = `translateX(${moveDist}px)`;
      });
      rightBrackets.forEach(el => {
        el.style.transform = `translateX(${-moveDist}px)`;
      });

      // fade text
      text.style.opacity = '0';

      // reset after animation and navigate if needed
      setTimeout(() => {
        leftBrackets.forEach(el => el.style.transform = '');
        rightBrackets.forEach(el => el.style.transform = '');
        text.style.opacity = '';

        if (isLink && href && href !== '#') {
          if (clickable.target === '_blank') window.open(href, '_blank');
          else window.location.href = href;
        }

        if (clickable.tagName.toLowerCase() === 'button') {
          clickable.dispatchEvent(new Event('animation-end'));
        }
      }, 300);
    };

    clickable.addEventListener('mousedown', animate);
    clickable.addEventListener('touchstart', animate, { passive: true });
    clickable.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') animate(e);
    });
  });
}

document.addEventListener('DOMContentLoaded', initBrackets);
